<template>
    <div class="ls-thanks__container">
        <ls-panel :hide-divider="true">
            <div class="grid__col-12 ls-align--center ls-thanks__inner-container">
                <p class="ls-margin--bottom">
                    <span class="fa-stack fa-2x ls-color--green">
                        <i class="fa fa-stack-2x fa-circle"></i>
                        <i class="fa fa-stack-1x fa-thumbs-up fa-inverse"></i>
                    </span>
                </p>

                <h2 class="ls-condensed ls-margin--bottom" test-id="heading">
                    Thank you! Your request has been submitted.
                </h2>
                <span v-if="outOfMarket" test-id="copy" class="ls-thanks__leadspedia-copy">
                    You will be contacted by local professionals with free estimates based on your
                    request.
                </span>
                <span v-else test-id="copy"
                    >We'll reach out to you once we find a crew to provide you a quote.</span
                >
            </div>
        </ls-panel>
    </div>
</template>

<script>
import lsPanel from '@/components/original-mydot/panel/Panel.vue';
import { mapState } from 'vuex';

export default {
    name: 'ThanksView',
    components: {
        lsPanel,
    },
    computed: {
        ...mapState(['featureFlags']),
        outOfMarket() {
            return this.$route.params.variant === 'out-of-market';
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-thanks__inner-container {
    padding: rem(8) rem(0);
}

.ls-thanks__leadspedia-copy {
    font-size: 13px;
}
</style>
